var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.061 12.526v8.421q0 .448-.296.75a.99.99 0 0 1-.734.303.99.99 0 0 1-.735-.303 1.03 1.03 0 0 1-.296-.75V3.053q0-.449.296-.75A.99.99 0 0 1 5.031 2h13.94q.285 0 .503.132.219.13.348.342.129.21.168.46a1 1 0 0 1-.065.513L18.43 7.263l1.495 3.816q.103.262.064.513-.038.25-.167.46a1 1 0 0 1-.348.343.96.96 0 0 1-.502.131z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFill);
export default __webpack_public_path__ + "static/media/Flag_fill.56f43ef5a7c73a26164a82ef2a194c76.svg";
export { ForwardRef as ReactComponent };